(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navigation"] && !Shopify.designMode) return;
  try {
    
// Curated, ordered in-page nav. Each item resolves to the first selector that
// matches on the page (PDP templates vary), targeting stable section-type /
// app-block ids so it survives restyles. Items with no match are skipped, and
// pills render in this exact order regardless of DOM position.
const PAGE_NAV_ITEMS = [
  { label: 'Gallery', selectors: ['.product__primary-left', '[id*="__product_gallery"]', '.product-gallery-grid', '.product_media_box'] },
  { label: 'Compare', selectors: ['[id*="__product_introduction"]'] },
  { label: 'FAQ',     selectors: ['[id*="__product_faq"] product-faq', '.details_faq'] },
  { label: 'Reviews', selectors: ['[id*="judge_me_reviews_review_widget"]', '[id*="judge-me-reviews-review-widget"]', '.jdgm-widget', '.jdgm-rev-widg', '[id*="amazon_reviews_by_appio"]', '.appio-header-container'] },
];

class InPageNav extends HTMLElement {
  #boundResize = null;

  connectedCallback() {
    this.nav = this.querySelector('.navigation-container');
    if (!this.nav) return;
    const offset = 'calc(var(--pdp-pinned-top, 0px) + var(--page-nav-height, 0px) + 20px)';
    this.items = PAGE_NAV_ITEMS
      .map((item) => ({ label: item.label, el: this.#resolve(item.selectors) }))
      .filter((item) => item.el);
    if (this.items.length === 0) {
      this.hidden = true; // nothing to navigate to on this page
      return;
    }
    this.items.forEach((item, index) => {
      if (!item.el.id) item.el.id = `pdp-nav-${index}`;
      item.el.style.scrollMarginBlockStart = offset; // land below whatever is pinned + this nav
    });
    this.#render();
    this.#publishHeight();
    this.#observe();
    this.#boundResize = this.#publishHeight.bind(this);
    window.addEventListener('resize', this.#boundResize);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    if (this.#boundResize) window.removeEventListener('resize', this.#boundResize);
  }

  #resolve(selectors) {
    for (const selector of selectors) {
      const el = document.querySelector(selector);
      // Skip hidden placeholders (e.g. the collapsed Shopify Product Reviews accordion
      // shell) so we only navigate to visible review widgets.
      if (el && el.offsetParent !== null) return el;
    }
    return null;
  }

  #render() {
    this.links = this.items.map((item) => {
      const link = document.createElement('a');
      link.className = 'navigation-item';
      link.href = `#${item.el.id}`;
      link.textContent = item.label;
      link.addEventListener('click', (event) => this.#onClick(event, item.el));
      return link;
    });
    this.nav.replaceChildren(...this.links);
  }

  #publishHeight() {
    document.documentElement.style.setProperty('--page-nav-height', `${this.offsetHeight}px`);
  }

  #onClick(event, target) {
    this.#setActive(target.id); // immediate feedback even when the click causes little/no scroll
    // Reduced motion: let the native #anchor jump happen (it honours scroll-margin).
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Otherwise smooth-scroll via window.scrollTo — reliable for long distances,
    // unlike scrollIntoView({behavior:'smooth'}) which can no-op for far targets.
    event.preventDefault();
    // Read this section's own resolved `top`, not --pdp-pinned-top directly:
    // getPropertyValue on a custom property returns an unevaluated token sequence
    // ("max(34px, 34px)"), which parseFloat turns into NaN. The sticky element's
    // computed `top` is already resolved to px and is by definition the same number.
    const pinnedH = parseFloat(getComputedStyle(this.closest('[id^="shopify-section-"]') || this).top) || 0;
    const navH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--page-nav-height')) || 0;
    const y = target.getBoundingClientRect().top + window.scrollY - (pinnedH + navH + 20);
    window.scrollTo({ top: y, behavior: 'smooth' });
    history.replaceState(null, '', `#${target.id}`);
  }

  #observe() {
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) this.#setActive(entry.target.id);
        }
      },
      { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
    );
    for (const item of this.items) this.observer.observe(item.el);
  }

  #setActive(id) {
    for (const link of this.links) {
      const isActive = link.getAttribute('href') === `#${id}`;
      link.classList.toggle('active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'true');
        this.#centerActive(link);
      } else {
        link.removeAttribute('aria-current');
      }
    }
  }

  #centerActive(link) {
    const offset = link.offsetLeft - this.nav.offsetWidth / 2 + link.offsetWidth / 2;
    // Instant: a horizontal smooth scroll here would cancel the page's vertical
    // smooth scroll when both are initiated in the same tick (on click).
    this.nav.scrollTo({ left: offset });
  }
}

customElements.define('in-page-nav', InPageNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-quiz"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSizeQuiz(section) {
    var buttons = section.querySelectorAll('.size-quiz__option');
    // No hardcoded "All" button — all options come from blocks

    if (!buttons.length) return;

    function getCollectionInstance() {
      try {
        if (!window.Shopify || !window.Shopify.theme || !window.Shopify.theme.sections) return null;
        var instances = window.Shopify.theme.sections.instances;
        if (!instances || !instances.length) return null;
        for (var i = 0; i < instances.length; i++) {
          if (instances[i].type === 'collection') return instances[i];
        }
      } catch (e) {
        /* Private API may change — fall through to URL navigation */
      }
      return null;
    }

    function scrollToGrid() {
      var grid = document.querySelector('[data-section-type="collection"]');
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function applyFilter(filterParams) {
      var collection = getCollectionInstance();
      if (collection && typeof collection._renderView === 'function') {
        try {
          collection._renderView(filterParams, true);
          if (filterParams) scrollToGrid();
          return;
        } catch (e) {
          /* Private API failed — fall through to URL navigation */
        }
      }
      if (filterParams) {
        window.location.href = window.location.pathname + '?' + filterParams;
      } else {
        window.location.href = window.location.pathname;
      }
    }

    // On page load, sync button states with current URL
    var currentSearch = window.location.search.replace(/^\?/, '');
    if (currentSearch) {
      Array.prototype.forEach.call(buttons, function(btn) { btn.setAttribute('aria-checked', 'false'); });
      Array.prototype.forEach.call(buttons, function(btn) {
        var params = btn.dataset.filterParams || '';
        if (params && currentSearch === params) {
          btn.setAttribute('aria-checked', 'true');
        }
      });
    } else if (buttons.length) {
      // No filter in URL — visually select first option and apply via AJAX only (no redirect)
      buttons[0].setAttribute('aria-checked', 'true');
      var firstParams = buttons[0].dataset.filterParams;
      if (firstParams) {
        var retries = 0;
        var tryApply = function() {
          var collection = getCollectionInstance();
          if (collection && typeof collection._renderView === 'function') {
            try { collection._renderView(firstParams, true); } catch (e) {}
          } else if (retries < 20) {
            retries++;
            setTimeout(tryApply, 200);
          }
        };
        tryApply();
      }
    }

    Array.prototype.forEach.call(buttons, function(btn) {
      btn.addEventListener('click', function() {
        var wasActive = btn.getAttribute('aria-checked') === 'true';
        if (wasActive) return;

        var filterParams = btn.dataset.filterParams;

        Array.prototype.forEach.call(buttons, function(b) { b.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');

        applyFilter(filterParams);
      });
    });
  }

  var sections = document.querySelectorAll('[data-section-type="size-quiz"]');
  Array.prototype.forEach.call(sections, initSizeQuiz);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swatch-fabric-highlights"] && !Shopify.designMode) return;
  try {
    
class SwatchFabricHighlights extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelectorAll('details');
    this.setupAccordion();
  }

  setupAccordion() {
    this.details.forEach((detail) => {
      detail.querySelector('summary').addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = detail.hasAttribute('open');

        if (isOpen) {
          detail.removeAttribute('open');
        } else {
          detail.setAttribute('open', '');
        }
      });
    });
  }
}

if (!customElements.get('swatch-fabric-highlights')) {
  customElements.define('swatch-fabric-highlights', SwatchFabricHighlights);
}

  } catch(e) { console.error(e); }
})();
})();
